module.exports = __webpack_public_path__ + "img/123.0e3e2808.jpg";